// DO NOT EDIT -- generated from fs/services/grant/groups.proto

import { Access } from './access.proto';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';

export namespace Groups {

  export const CreateGroupEndpoint = "/grpc/grant.Groups/CreateGroup";
  /** Creates a new group that can be used for group assignment and access control. */
  export function CreateGroup(sender: (req: CreateGroupRequest, endpoint: string) => Promise<CreateGroupResponse>, req: CreateGroupRequest): { promise: () => Promise<CreateGroupResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateGroupEndpoint),
      endpoint: CreateGroupEndpoint
    };
  }

  export const UpdateGroupEndpoint = "/grpc/grant.Groups/UpdateGroup";
  /** Updates an existing group. */
  export function UpdateGroup(sender: (req: UpdateGroupRequest, endpoint: string) => Promise<UpdateGroupResponse>, req: UpdateGroupRequest): { promise: () => Promise<UpdateGroupResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateGroupEndpoint),
      endpoint: UpdateGroupEndpoint
    };
  }

  export const UpdateGroupArchivedEndpoint = "/grpc/grant.Groups/UpdateGroupArchived";
  /** Archives or unarchives a group */
  export function UpdateGroupArchived(sender: (req: UpdateGroupArchivedRequest, endpoint: string) => Promise<UpdateGroupArchivedResponse>, req: UpdateGroupArchivedRequest): { promise: () => Promise<UpdateGroupArchivedResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateGroupArchivedEndpoint),
      endpoint: UpdateGroupArchivedEndpoint
    };
  }

  export const GetGroupEndpoint = "/grpc/grant.Groups/GetGroup";
  /** Retrieves an existing group. */
  export function GetGroup(sender: (req: GetGroupRequest, endpoint: string) => Promise<GetGroupResponse>, req: GetGroupRequest): { promise: () => Promise<GetGroupResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetGroupEndpoint),
      endpoint: GetGroupEndpoint
    };
  }

  export const ListGroupsEndpoint = "/grpc/grant.Groups/ListGroups";
  /** Lists available groups for the corresponding filters. */
  export function ListGroups(sender: (req: ListGroupsRequest, endpoint: string) => Promise<ListGroupsResponse>, req: ListGroupsRequest): { promise: () => Promise<ListGroupsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListGroupsEndpoint),
      endpoint: ListGroupsEndpoint
    };
  }

  export const DeleteGroupsEndpoint = "/grpc/grant.Groups/DeleteGroups";
  /** Deletes one or more groups and their associated memberships. */
  export function DeleteGroups(sender: (req: DeleteGroupsRequest, endpoint: string) => Promise<DeleteGroupsResponse>, req: DeleteGroupsRequest): { promise: () => Promise<DeleteGroupsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteGroupsEndpoint),
      endpoint: DeleteGroupsEndpoint
    };
  }
}

export interface GroupRecord {
  group: Group | null;
  members: string[];
  /**
   * Deprecated: use space_accesses instead
   * 
   * @deprecated
   */
  viewableSpaces: string[];
  spaceAccesses: Access.Space[];
  metadata: protoauditstore.AuditMetadata | null;
  dataClassificationAccesses: Access.DataClassification[];
}

export interface Group {
  /** this type is only use in one request type (UpdateGroupRequest), so this shouldn't affect anything else */
  id: string;
  name: string;
  description: string;
}

export interface CreateGroupRequest {
  orgId: string;
  creator: string;
  name: string;
  description: string;
}

export interface CreateGroupResponse {
  group: GroupRecord | null;
}

export interface UpdateGroupRequest {
  orgId: string;
  updater: string;
  group: Group | null;
}

export interface UpdateGroupResponse {
  group: GroupRecord | null;
}

export interface GetGroupRequest {
  orgId: string;
  id: string;
  includeMemberships: boolean;
  /**
   *  Deprecated: use include_space_accesses instead
   * 
   * @deprecated
   */
  includeViewableSpaces: boolean;
  includeSpaceAccesses: boolean;
  includeDataClassificationAccesses: boolean;
}

export interface GetGroupResponse {
  group: GroupRecord | null;
}

export interface ListGroupsRequest {
  orgId: string;
  includeMemberships: boolean;
  /**
   *  Deprecated: use include_space_accesses instead
   * 
   * @deprecated
   */
  includeViewableSpaces: boolean;
  includeSpaceAccesses: boolean;
  includeDataClassificationAccesses: boolean;
}

export interface ListGroupsResponse {
  groups: GroupRecord[];
}

export interface UpdateGroupArchivedRequest {
  orgId: string;
  id: string;
  archived: boolean;
}

export interface UpdateGroupArchivedResponse {
  group: GroupRecord | null;
}

export interface DeleteGroupsRequest {
  orgId: string;
  groupIds: string[];
}

export interface DeleteGroupsResponse {
  failedGroupIds: string[];
  errorMessages: string[];
}
